const __WEBPACK_NAMESPACE_OBJECT__ = Object.assign(sc5.default || sc5, sc5);